import * as React from 'react';
export const MASvg = React.forwardRef(function MASvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#B1372F',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#159570',
        fillRule: 'nonzero',
        d: 'm10.755 5-1.75.004a.243.243 0 0 1-.231-.168L8.232 3.17a.243.243 0 0 0-.464 0l-.54 1.664a.243.243 0 0 1-.231.168H5.246a.243.243 0 0 0-.143.441l1.415 1.03a.243.243 0 0 1 .089.272l-.54 1.665a.243.243 0 0 0 .375.272l1.415-.95a.243.243 0 0 1 .287 0l1.416.95a.243.243 0 0 0 .376-.272l-.542-1.665a.243.243 0 0 1 .088-.273l1.416-1.029A.246.246 0 0 0 10.755 5Z',
      }),
    ),
  );
});
MASvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var MA = {
  category: 'flag',
  colorable: false,
  name: 'MA',
  svg: MASvg,
};
